/* src/app/pages/refinamiento/verpagorefinamiento/verpagorefinamiento.component.scss */
/*# sourceMappingURL=verpagorefinamiento.component.css.map */
